import React from 'react';

import UploadForm from './UploadForm';


const UploadPage = () => {

        return (
        <div>
        <div className="upload-page">
            <UploadForm />
        </div>
        </div>
    );
}

export default UploadPage;